/*global crdl */
import { all, call, fork, select, put, take } from 'redux-saga/effects';

export function* setupCordial() {
    const key = yield select(state => state.cordial && state.cordial.key);

    window.CordialObject = 'crdl';
    window.crdl = window.crdl || ((...args) => {(window.crdl.q = window.crdl.q || []).push(args);});
    window.crdl.l = 1 * new Date;
    window.crdl.q = [];

    yield call(window.crdl, 'connect', key, {
        trackUrl: '//se.cordial-tracking.tarot.com',
        connectUrl: '//d.cordial-tracking.tarot.com',
        cookieDomain: 'tarot.com',
        cookieLife: 365,
    });

    yield call(() => new Promise((resolve) => {
        const tag = document.createElement('script');
        tag.async = 1;
        tag.onload = resolve;
        tag.src = '//d.cordial-tracking.tarot.com/track.v2.js';
        document.body.appendChild(tag);
    }));
}

function* getBrowseEvent() {
    const [ desc, teeup ] = yield all([
        select(state => state.product.description),
        select(state => state.product.teeup),
    ]);

    if (desc) {
        return {
            category: desc.categories[0],
            product: desc.product_name,
            productID: desc.code,
            placement: 'teeup',
        };
    } else if (teeup) {
        return {
            category: teeup.product_type,
            product: teeup.display_name,
            productID: teeup.code,
            placement: 'module',
        };
    }

    return null;
}

export function* sendSavedBrowseEvents() {
    const events = yield select(state => state.cookie['cordial-events'] || []);
    const impersonate = yield select(state => state.cookie.impersonate || null);

    if (!impersonate) {
        yield put({ type: 'cookie:remove', payload: 'cordial-events' });

        yield all(events.slice(-5).map((event) =>
            call(crdl, 'event', 'browse', event)
        ));
    }
}

export function* saveBrowseEvent(event) {
    const events = yield select(state => state.cookie['cordial-events'] || []);
    events.push(event);
    yield put({ type: 'cookie:set', payload: {
        name: 'cordial-events',
        value: events,
        opts: { expires: .042 }, // .042 = about 1 hour
    }});
}

export function* sendEvent(event, action) {
    const impersonate = yield select(state => state.cookie.impersonate || null);
    try {
        if (!impersonate) {
            yield call(crdl, 'event', action, event);
        }
    } catch(e) {
        return;
    }
}

export function* sendBrowseEvent(event) {
    yield call(sendEvent, event, 'browse', 'sendBrowseEvent');
}

export function* sendBrowsePageEvent(event) {
    yield call(sendEvent, event, 'browse-page', 'sendBrowsePageEvent');
}

export function* getCartEvent() {
    const [ order_uuid, product ] = yield all([
        select(state => state.checkout && state.checkout.order && state.checkout.order.order_uuid),
        select(state => state.checkout && state.checkout.order && state.checkout.order.items[0]),
    ]);
    if (order_uuid && product) {
        if (! product.remote_key || ! product.remote_key.startsWith('SVC-')) {
            return null;
        }

        return {
            upc: product.upc,
            order_uuid: order_uuid,
            report: product.remote_key.substring(4),
        };
    }
    return null;
}

export function* sendCartEvent(event) {
    yield call(sendEvent, event, 'cart', 'sendCartEvent');
}

export function* watchUser() {
    while (true) {
        const user = yield select(state => state.user);
        if (user.member_uuid) {
            /* contact() is now acting as identify from v1 */
            try {
                yield call(crdl, 'contact', { m_uuid: user.member_uuid }, {});
            } catch(f) {
                //continue
            }
            try {
                yield call(sendSavedBrowseEvents);
            } catch(e) {
                //continue
            }
        } else {
            try {
                yield call(crdl, 'forget');
            } catch(e) {
                //continue
            }
        }

        yield take(['user:logged-in', 'user:logged-out']);
    }
}

export function* watchBrowseEvents() {
    while (true) {
        const [event, user] = yield all([
            call(getBrowseEvent),
            select(state => state.user),
        ]);

        if (event && user.member_uuid) {
            yield call(sendBrowseEvent, event);
        } else {
            yield call(saveBrowseEvent, event);
        }

        yield take('cordial:browse');
    }
}

export function* watchBrowsePage() {
    while (true) {
        const tags = yield select(state => state.cordial && state.cordial.tags);

        if (tags) {
            const event = {
                url: document.location.href,
                title: document.title,
                tags: tags,
            };

            yield call(sendBrowsePageEvent, event);
        }

        yield take('cordial:page');
    }
}

export function* watchCart() {
    while (true) {
        const [event, user] = yield all([
            call(getCartEvent),
            select(state => state.user),
        ]);
        if (event && user.member_uuid) {
            yield call(sendCartEvent, event);
        }

        yield take('cordial:cart');
    }
}

export function* root() {
    yield take('cordial:init');

    yield call(setupCordial);

    yield all([
        fork(watchUser),
        fork(watchBrowseEvents),
        fork(watchBrowsePage),
        fork(watchCart),
    ]);
}
